import { Nullable, Uuid } from '@/api/types';
import { DonorType, OrganType } from '@/api/apis/case/index';

export enum AcceptanceCriteriaWarmIschemicTimeType {
  SystolicLessThan80 = 'SystolicLessThan80',
  SystolicLessThan50 = 'SystolicLessThan50',
  MapLessThan50 = 'MapLessThan50',
  SystolicLessThan80SaturationLessThan80 = 'SystolicLessThan80SaturationLessThan80',
}

export enum AcceptanceCriteriaBiopsy {
  Yes = 'Yes',
  BasedOnVisual = 'BasedOnVisual',
}

export type OrganAcceptanceCriteriaFields = HeartDCDAcceptanceCriteriaFields &
  HeartDBDAcceptanceCriteriaFields &
  LiverAcceptanceCriteriaFields &
  LungsAcceptanceCriteriaFields;

export type OrganAcceptanceCriteriaFieldsTemplate = OrganAcceptanceCriteriaFields & {
  organType: OrganType | 'None';
  donorType: DonorType | 'None';
};

export type OrganAcceptanceCriteriaTemplate = OrganAcceptanceCriteriaFields & {
  id: Uuid;
  modifiedAt: string | null;
  modifiedBy: string | null;
  organType: OrganType | 'None';
  donorType: DonorType | 'None';
};

export type HeartDCDAcceptanceCriteriaFields = {
  totalExtubationTime?: number;
  systolicTimeInitiation?: Nullable<number>;
  saturationTimeInitiation?: Nullable<number>;
  clockRestarts?: boolean;
  warmIschemicTimeEnds?: Nullable<string>;
  totalWarmIschemicTime?: number;
};

export type HeartDBDAcceptanceCriteriaFields = {
  extraDonorTissueRequests?: Nullable<string>;
};

export type LiverAcceptanceCriteriaFields = {
  totalExtubationTime?: number;
  warmIschemicTime?: number;
  warmIschemicTimeType?: AcceptanceCriteriaWarmIschemicTimeType;
  fromExtubationToColdFlush?: number;
  biopsyType?: AcceptanceCriteriaBiopsy;
  AsCaseCreationStep?: boolean;
};

export type LungsAcceptanceCriteriaFields = object;
